module.exports = __webpack_public_path__ + "static/media/books_logo.8fdcfe87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/books_logo.svg
// module id = 157
// module chunks = 0